<template>
  <div class="product-section">
    <div class="modal-heading">
      <h2>{{$t('FileCloud Online')}}</h2>
      <p>{{$t('Run FileCloud on our secure infrastructure')}}</p>
    </div>
    <ComparisonTable
      :plans="plans"
      :feature-labels="featureLabels"
      @select="onSelect"
    />
  </div>
</template>

<script>
import { onlineBenefits } from '@/constants/checkout';
import ComparisonTable from '@/components/Checkout/ComparisonTable.vue';

export default {
  name: 'Online',
  components: {
    ComparisonTable
  },
  props: {
    currentProps: {
      type: Object,
      default: () => {}
    },
    products: {
      type: Object,
      default: () => {}
    }
  },
  data() {
    return {
      benefits: onlineBenefits
    };
  },
  computed: {
    sectionProducts() {
      return this.products[this.currentProps.group] ? this.products[this.currentProps.group] : {
        essentials: {},
        advanced: {},
      }
    },
    plans() {
      const planDefs = [
        { key: 'essentials', name: this.$t('Essentials') },
        { key: 'advanced', name: this.$t('Advanced'), recommended: true },
        { key: 'fedramp', name: this.$t('FedRAMP High') },
      ];
      return planDefs.map(def => ({
        ...def,
        product: this.sectionProducts[def.key] || {},
        benefits: this.benefits[def.key] || [],
      }));
    },
    featureLabels() {
      const first = this.benefits.essentials;
      return first ? first.map(b => b.label) : [];
    },
  },
  mounted() {
    this.$emit('settings', {
      secondary: (this.currentProps.previousStep) ? 'Back' : null
    })
  },
  methods: {
    onSelect(type) {
      if(this.sectionProducts[type] && this.sectionProducts[type].allowusertobuy) {
        this.$emit('changeStep', { step: 'details', props: { type } });
      } else {
        this.$modal.show('request-quote');
      }
    },
    onClickSecondary() {
      this.$emit('changeStep', { step: 'welcome' });
    }
  }
};
</script>
